<template>
  <header class="employee">
    <nav class="navbar navbar-expand-lg navbar-light bg-nav">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#">Latest Jobs</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="#">Post Resume</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Govt. Jobs</a>
          </li>
        </ul>
        <div class="login">
          <a class="nav-link" href="#"><i class="fa fa-user"></i> login</a>
        </div>
        <form class="form-inline">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text btn-sm search-btn" id="basic-addon1"
                ><img src="@/assets/images/search-icon.png"
              /></span>
            </div>
            <button type="submit" class="form-control search-input">
              Employer/Recruiter
            </button>
          </div>
        </form>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="logo">
        <a
          class="hidden-xs hidden-sm"
          href="/"
          title="The incircle"
          data-toggle="tooltip"
          ><img src="@/assets/images/logo-hin.png"
        /></a>
      </div>
      <div class="employee-icon d-block d-sm-none">
        <span class="mr-0"
          ><a><i class="fa fa-user"></i>login</a></span
        >
      </div>
    </div>
  </header>
</template>

<script>
export default { name: "HeaderEmployee" };
</script>
